/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Holiday
 * 
 * 1 = Sickness
 * 
 * 2 = BankHoliday
 * 
 * 3 = Other
 */
export enum LeaveType {
  Holiday = 0,
  Sickness = 1,
  BankHoliday = 2,
  Other = 3
}
